import { render, staticRenderFns } from "./UOttawaLab2SelfAssessmentFr.vue?vue&type=template&id=1e0a5b7d&scoped=true&"
import script from "./UOttawaLab2SelfAssessmentFr.vue?vue&type=script&lang=ts&"
export * from "./UOttawaLab2SelfAssessmentFr.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0a5b7d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VContainer,VForm,VSimpleTable,VTextField})
